



























































import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
import { storePemeriksaanFisikRalan } from "@/store/modules/pemeriksaanfisikralan";
import { storeNyeri } from "@/store/modules/nyeri";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import AsesmenNyeri from "@/components/pemeriksaan/assesmen/AsesmenNyeri.vue";
import { getFormattedDateTime } from "@/utility/DateUtils";
import { confirmRemove } from "@/utility/CommonHelper";
import AsesmenNyeriSvc from "@/services/AsesmenNyeri";
import FormAuthorization from "@/mixins/FormAuthorization";
import storeRefAsesmen from "@/store/modules/new/ReferensiAsesmen";

@Component({
  components: {
    AsesmenNyeri
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class AsesmenNyeriPage extends Mixins(FormAuthorization) {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }
  sess_login = userModule.user;
  getparam = {
    unit_id: this.sess_login.unit_id,
    reg: this.register
  };

  nyeri = null;

  loadingSimpan = false;

  headers = [
    { text: "Metode", value: "metode" },
    { text: "Skala", value: "skala" },
    { text: "Unit", value: "unit.nama" },
    { text: "Petugas", value: "user.nama" },
    { text: "Waktu", value: "examined_at" },
    { text: "Aksi", value: "id" }
  ];

  sortBy = "created_at";
  sortDesc = true;

  expanded = [];

  get sessLogin() {
    return userModule.user;
  }
  get statePemeriksaanFisikRalan() {
    return storePemeriksaanFisikRalan.pemeriksaanfisikralan;
  }
  get stateNyeri() {
    // return this.listNyeri[0];
    return null;
  }
  get listNyeri() {
    return storeNyeri.detailnyeri;
  }
  get loadingList() {
    return appModule.loading;
  }

  mounted() {
    const getparam = {
      unit_id: userModule.user.unit_id,
      reg: this.register
    };

    storeNyeri.actNyeriByReg(getparam);
  }

  expandRow(item) {
    //
  }

  edit(itemId) {
    const item = this.listNyeri.find(it => it.id === itemId);

    if (this.validateUserEdit(item?.user.id)) {
      this.setNyeri(this.listNyeri.find(item => item.id == itemId));
    }
  }

  remove(id) {
    const item = this.listNyeri.find(it => it.id === id);

    if (
      this.validateUserEdit(item?.user.id) &&
      confirmRemove("Asesmen Nyeri")
    ) {
      // const row = this.risjatList.find(it => it.id == id);

      // row.deleting = true;

      AsesmenNyeriSvc.destroy(id)
        .then(resp => {
          if (resp.status == 1) {
            appModule.NoticeDelay("Berhasil menghapus asesmen risiko jatuh");
          } else {
            alert(resp.message);
          }
        })
        .finally(() => {
          // row.deleting = false;

          storeNyeri.actNyeriByReg({
            unit_id: userModule.user.unit_id,
            reg: this.register
          });
        });
    }
  }

  getDateTime(date) {
    return getFormattedDateTime(date, "DD-MM-YYYY HH:mm");
  }

  setNyeri(val) {
    console.log("set nyeri", val);
    this.nyeri = val;
  }

  setPerawat(val) {
    this.nyeri["user"] = val;
  }

  clearNyeri() {
    console.log("clear nyeri");
    this.setNyeri(null);
  }

  snakeToTitleCase(str) {
    return str
      .split("_") // Split the string by underscores
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(" "); // Join the words with a space
  }

  uCaseTitle(val: string) {
    return val?.toUpperCase();
  }

  parseRowExpandableItem(item) {
    const ext = {
      pencetus: item.pencetus,
      penyebab_nyeri_hilang: item.penyebab_hilang,
      kualitas_nyeri: item.kualitas,
      lokasi: item.lokasi,
      frekuensi: item.frekuensi,
      durasi: item.durasi,
      intensitas: item.intensitas,
      pola_serangan: item.pola_serangan,
      jenis: item.jenis
    };
    const extArr = Object.fromEntries(
      Object.entries(ext).filter(([key, value]) => value !== null)
    );
    const extStr = Object.entries(extArr).map(([key, val]) => {
      let unit = "";
      if (key === "durasi") {
        unit = " dtk";
      } else if (key === "frekuensi") {
        unit = " x/10 mnt";
      } else if (key === "jenis") {
        val = val == 1 ? "Kronis" : val == "0" ? "Akut" : "-";
      }

      return `${this.snakeToTitleCase(key)}: ${val + unit}`;
    });

    const paramStr = item.question
      .map(it => {
        // return it.ref_group_id;
        if (it.ref_group_id) {
          return (
            this[`category${item.metode.toUpperCase()}`].find(
              cat => cat.id == it.ref_group_id
            ).title +
            ": " +
            this[`category${item.metode.toUpperCase()}`]
              .find(cat => cat.id == it.ref_group_id)
              ?.val.find(val => val.id == it.ref_id)?.title
          );
        }
      })
      .join("<br/>");

    return `<table style="width: 100%;">
      <tr>
        <td style="width: 50%;">
          ${paramStr}
        </td>
        <td style="width: 50%;">
          ${extStr.join("<br/>")}
        </td>
      </tr>
    </table>`;
  }

  get categoryNIPS() {
    return storeRefAsesmen.nyeriNIPS;
  }

  get categoryFLACC() {
    return storeRefAsesmen.nyeriFLACC;
  }

  get categoryBPS() {
    return storeRefAsesmen.nyeriBPS;
  }
}
